import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7082/Staff";
	}
	createStaffMember(e, t) {
		let r = this.baseUrl + "/CreateStaffMember", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCreateStaffMember(e)));
	}
	processCreateStaffMember(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : w("An unexpected server error occurred.", e.status, e.data, t);
	}
	deleteStaffMember(e, t) {
		let r = this.baseUrl + "/DeleteStaffMember", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processDeleteStaffMember(e)));
	}
	processDeleteStaffMember(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : w("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAllStaff(e) {
		let t = this.baseUrl + "/GetAllStaff", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAllStaff(e)));
	}
	processGetAllStaff(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : w("An unexpected server error occurred.", e.status, e.data, t);
	}
	getStaff(e, t) {
		let r = this.baseUrl + "/GetStaff";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
		r += "id=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetStaff(e)));
	}
	processGetStaff(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? w("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : w("An unexpected server error occurred.", e.status, e.data, t);
	}
	getStaffByRoles(e, t) {
		let r = this.baseUrl + "/GetStaffByRoles", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetStaffByRoles(e)));
	}
	processGetStaffByRoles(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : w("An unexpected server error occurred.", e.status, e.data, t);
	}
	sendInvitationEmail(e, t) {
		let r = this.baseUrl + "/SendInvitationEmail", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSendInvitationEmail(e)));
	}
	processSendInvitationEmail(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : w("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffAddNote(e, t) {
		let r = this.baseUrl + "/StaffAddNote", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffAddNote(e)));
	}
	processStaffAddNote(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : w("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffDeleteNote(e, t) {
		let r = this.baseUrl + "/StaffDeleteNote", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffDeleteNote(e)));
	}
	processStaffDeleteNote(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 404 ? w("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : w("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetNotes(e, t, r) {
		let i = this.baseUrl + "/StaffGetNotes";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'catalogueType' must be defined and cannot be null.");
		if (i += "catalogueType=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'catalogueId' must be defined and cannot be null.");
		i += "catalogueId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffGetNotes(e)));
	}
	processStaffGetNotes(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : w("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffSetNoteColour(e, t) {
		let r = this.baseUrl + "/StaffSetNoteColour", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffSetNoteColour(e)));
	}
	processStaffSetNoteColour(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : e.status === 400 ? w("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 404 ? w("No description", e.status, e.data, t) : w("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffToggleNotePin(e, t) {
		let r = this.baseUrl + "/StaffToggleNotePin", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffToggleNotePin(e)));
	}
	processStaffToggleNotePin(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 404 ? w("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : w("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateStaffMember(e, t) {
		let r = this.baseUrl + "/UpdateStaffMember", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateStaffMember(e)));
	}
	processUpdateStaffMember(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : w("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.Agency = "Agency", e.Campaign = "Campaign", e.Contract = "Contract", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.Agency = "Agency", e.Campaign = "Campaign", e.Contract = "Contract", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.Agency = "Agency", e.Campaign = "Campaign", e.Contract = "Contract", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.Green = "Green", e.Purple = "Purple", e.Blue = "Blue", e.Teal = "Teal", e.Yellow = "Yellow", e.Red = "Red", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.Agency = "Agency", e.Campaign = "Campaign", e.Contract = "Contract", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.Green = "Green", e.Purple = "Purple", e.Blue = "Blue", e.Teal = "Teal", e.Yellow = "Yellow", e.Red = "Red", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.Agency = "Agency", e.Campaign = "Campaign", e.Contract = "Contract", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), C = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isStaffApiException = !0;
	static isStaffApiException(e) {
		return e.isStaffApiException === !0;
	}
};
function w(e, t, n, r, i) {
	throw i ?? new C(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var T = "staff";
function E(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var D = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), E(r);
}, O = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[T] || `${e}/${T}`;
}, k = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = O(i), u = c, d = D(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = D(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, A = a({}), j = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = k(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(A.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, M = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(A), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.createStaffMember(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		createStaffMember: u,
		createStaffMemberPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, N = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(A), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.deleteStaffMember(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		deleteStaffMember: u,
		deleteStaffMemberPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, P = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(A), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAllStaff"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAllStaff(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, F = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAllStaff"] });
	}, e[0] = t, e[1] = n), n;
}, I = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(A), s;
	n[0] === e ? s = n[1] : (s = ["getStaff", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getStaff(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, L = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getStaff", e] });
	}, e[0] = t, e[1] = n), n;
}, R = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(A), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getStaffByRoles(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getStaffByRoles: u,
		getStaffByRolesPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, z = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(A), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.sendInvitationEmail(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		sendInvitationEmail: u,
		sendInvitationEmailPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, B = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(A), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffAddNote(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffAddNote: u,
		staffAddNotePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, V = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(A), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffDeleteNote(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffDeleteNote: u,
		staffDeleteNotePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, H = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(A), c;
	i[0] !== t || i[1] !== e ? (c = [
		"staffGetNotes",
		e,
		t
	], i[0] = t, i[1] = e, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== t || i[5] !== e ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetNotes(e, t, r);
	}, i[3] = s, i[4] = t, i[5] = e, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, U = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetNotes",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, W = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(A), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffSetNoteColour(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffSetNoteColour: u,
		staffSetNoteColourPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, G = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(A), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffToggleNotePin(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffToggleNotePin: u,
		staffToggleNotePinPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, K = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(A), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateStaffMember(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateStaffMember: u,
		updateStaffMemberPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
};
//#endregion
export { m as AddNoteRequestCatalogueType, h as DeleteNoteRequestCatalogueType, g as SetNoteColourRequestCatalogueType, _ as SetNoteColourRequestColour, A as StaffApiContext, C as StaffApiException, j as StaffApiProvider, p as StaffClient, v as StaffNoteModelCatalogueType, y as StaffNoteModelColour, T as StaffRoute, b as States, x as ToggleNotePinRequestCatalogueType, S as UploadedDocumentDocumentType, M as useCreateStaffMember, N as useDeleteStaffMember, P as useGetAllStaff, I as useGetStaff, R as useGetStaffByRoles, F as useInvalidateUseGetAllStaff, L as useInvalidateUseGetStaff, U as useInvalidateUseStaffGetNotes, z as useSendInvitationEmail, B as useStaffAddNote, k as useStaffClientContext, V as useStaffDeleteNote, H as useStaffGetNotes, W as useStaffSetNoteColour, G as useStaffToggleNotePin, K as useUpdateStaffMember };
